import { render, staticRenderFns } from "./CheckboxField.vue?vue&type=template&id=069c852c&scoped=true&"
import script from "./CheckboxField.vue?vue&type=script&lang=js&"
export * from "./CheckboxField.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxField.vue?vue&type=style&index=0&id=069c852c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c852c",
  null
  
)

export default component.exports